module.exports = __webpack_public_path__ + "img/carrousel-mamo-10.71bf9e32.png";